export const formatDateToInput = (dateString) => {
    if (!dateString) return '';

    // Caso já esteja no formato dd/mm/yyyy → converter para yyyy-mm-dd
    if (dateString.includes('/')) {
        const [day, month, year] = dateString.split(' ')[0].split('/');
        return `${year}-${month}-${day}`;
    }

    // Caso venha com hora (ex: 2025-10-10 00:00:00) → converter para dd/mm/yyyy
    if (dateString.includes(' ') && dateString.includes('-')) {
        const [datePart] = dateString.split(' ');
        const [year, month, day] = datePart.split('-');
        return `${day}/${month}/${year}`;
    }

    // Caso venha no formato yyyy-mm-dd → retorna o mesmo (input padrão HTML)
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        return dateString;
    }

    // Caso venha no formato dd/mm/yyyy → retorna como está
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
        return dateString;
    }

    return dateString;
};
